/**
 * Гард сессии. Токены лежат в localStorage, а пользователь — нет: после
 * перезагрузки его надо дочитать из `/me`, иначе сайдбар не знает, кто вошёл,
 * а `can()` считает, что прав нет вовсе.
 */
import type { Router } from 'vue-router'

import { useAuthStore } from './store'

export const setupAuthGuard = (router: Router) => {
  router.beforeEach(async (to) => {
    const auth = useAuthStore()

    if (to.meta.public) {
      // Вошедшему на форме входа делать нечего.
      return auth.isAuthenticated && to.name === 'login' ? { path: '/my' } : true
    }

    if (!auth.isAuthenticated) {
      return { name: 'login', query: { redirect: to.fullPath } }
    }

    if (!auth.user) {
      try {
        await auth.loadUser()
      } catch {
        // Токен есть, но сессия мертва: интерцептор её уже не спас.
        auth.reset()

        return { name: 'login', query: { redirect: to.fullPath } }
      }
    }

    return true
  })
}
